"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InferredElement = exports.getElementsFromRecords = void 0;
var getElementsFromRecords_1 = __importDefault(require("./getElementsFromRecords"));
exports.getElementsFromRecords = getElementsFromRecords_1.default;
var InferredElement_1 = __importDefault(require("./InferredElement"));
exports.InferredElement = InferredElement_1.default;
__exportStar(require("./inferTypeFromValues"), exports);
__exportStar(require("./types"), exports);
